import { AuthenticatorSetupForm } from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";

export const AuthenticatorFormView = () => <AuthenticatorSetupForm />;
